import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import PatientSearch from "../../components/operator/patient-search";
import PatientTestReg from "../../components/operator/patient-test-reg";

function PatientTests() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState(true);
  const [Id, setId] = useState(null);

  return (
    <>
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {search && (
        <PatientSearch
          setLoader={setLoader}
          setSearch={setSearch}
          search={search}
          setId={setId}
          name="Patient Test"
          url="patient-test-search"
        />
      )}
      {!search && (
        <PatientTestReg setLoader={setLoader} setSearch={setSearch} id={Id} />
      )}
    </>
  );
}

export default PatientTests;
